import type { RouteConfig } from '@/types/route';
import InvitationReview from '../../invitationPromotion/invitationReviewRecord';

export const routeConfig: RouteConfig = {
  title: 'route.customerManagement.operationRecord',
  layout: true,
  sort: 3
};

export default InvitationReview;
